import React from 'react'

const ImageElement = (data) => {
  return (
    <div style={{ width: '100%', aspectRatio: data.aspectRatio, overflow: 'hidden' }}>
      <img
        src={data.content}
        alt={data.title}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover'
        }}
      />
    </div>
  )
}

export default ImageElement